import { default as ImageComponent } from "@/features/shared/components/image/image";
import type { WidgetConfiguration } from "@/lib/api";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

const Image = ({
  id,
  data,
}: {
  id: string;
  data: { url: string };
  configuration: WidgetConfiguration;
}) => {
  useRefetchWidget(id);

  if (!data?.url) return null;

  return <ImageComponent src={data.url} showCaption={false} />;
};

export default Image;
